<template>
  <div v-if="record.length>=2">
    <div>
      <span>{{ record[0][text] || ' ' }}
              <el-tooltip content="折叠更多" v-if="showToolTip[index]">
                <i class="el-icon-caret-top iconMore" @click="openMore(index)">折叠更多</i>
              </el-tooltip>
              <el-tooltip content="展开更多" v-if="!showToolTip[index]">
                <i class="el-icon-caret-bottom iconMore" @click="openMore(index)">展开更多</i>
              </el-tooltip>
            </span>
      <div v-for="(con,index1) in record" :key="index1" v-if="showToolTip[index]">
        <div v-if="index1!==0" >{{ con[text] || ' ' }}</div>
      </div>
    </div>
  </div>
  <div v-else-if="record.length<2 && record.length>0">
    {{ record[0][text] || ' ' }}
  </div>
</template>

<script>
export default {
  name: "ExFoldCell",
  props: ['text','record','index'],
  data() {
    return {
      showToolTip: [],
    }
  },
  methods: {
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}

</style>
